module.exports = __webpack_public_path__ + "img/customer10.e00963ad.jpg";